import * as yup from 'yup';

const IS_REQUIRED = (field) => `${field} is required`;
const NOT_VALID = (field) => `This ${field} is not valid`;
const URL = /(^$)|^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gmi


export const interviewSchema = yup.object().shape({
  fullName: yup.string().required(IS_REQUIRED('Full name')),
  email: yup.string().required(IS_REQUIRED('Email')).email(NOT_VALID('Email')),
  company: yup.string().required(IS_REQUIRED('Company')),
  availability: yup.string().required(IS_REQUIRED('Availability')),
});

export const loginSchema = yup.object().shape({
  email: yup.string().required(IS_REQUIRED('Email')).email(NOT_VALID('Email')),
  password: yup.string().required(IS_REQUIRED('Password')),
});

export const portfolioSchema = yup.object().shape({
  github: yup.string().nullable().url(NOT_VALID('Github url')),
  online: yup.string().nullable().url(NOT_VALID('Website url')),
});

export const certificationSchema = yup.object().shape({
  title: yup.string().required(IS_REQUIRED('Title')),
  year: yup.string().required(IS_REQUIRED('Year')),
  institution: yup.string().required(IS_REQUIRED('Institution')),
});

export const degreeSchema = yup.object().shape({
  title: yup.string().required(IS_REQUIRED('Title')),
  year: yup.string().required(IS_REQUIRED('Year')),
  university: yup.string().required(IS_REQUIRED('University')),
});

export const quoteSchema = yup.object().shape({
  author: yup.string().required(IS_REQUIRED('Author')),
  position: yup.string().required(IS_REQUIRED('Position')),
  company: yup.string().required(IS_REQUIRED('Company')),
  comment: yup.string().required(IS_REQUIRED('Comment')),
});

export const introduceSchema = yup.object().shape({
  firstName: yup.string().required(IS_REQUIRED('First name')),
  lastName: yup.string().required(IS_REQUIRED('Last name')),
  github: yup.string().nullable().url(NOT_VALID('Github url')),
  //github: yup.string().nullable().matches(URL, 'Enter a valid url'),
  online: yup.string().nullable().url(NOT_VALID('Website url')),
  //online: yup.string().nullable().matches(URL, 'Enter a valid url'),
  role: yup.string().required(IS_REQUIRED('Position'))
  /*role: yup.object()
    .shape({
      name: yup.string()
        .typeError(IS_REQUIRED('Position'))
        .required(IS_REQUIRED('Position')),
    }).typeError(IS_REQUIRED('Position')),
  city: yup.string().required(IS_REQUIRED('City')),
  country: yup.string().required(IS_REQUIRED('Country')),
  video: yup.string().required(IS_REQUIRED('Video')),
  availability: yup.string().required(IS_REQUIRED('Availability'))
  */
});

export const experienceSchema = yup.object().shape({
  company: yup.string().required(IS_REQUIRED('Company')),
  since: yup.date().typeError(IS_REQUIRED('Since')).default(() => `${new Date().toLocaleString('en-US', { month: 'long' })} ${new Date().getFullYear()}`).required(IS_REQUIRED('Since')),
  //since: yup.date().typeError(IS_REQUIRED('Since')).required(IS_REQUIRED('Since')),
  //until: yup.date().when("since", (since, yup) => since && yup.min(since, "'Until' date cannot be before 'since' date")),
  until:yup.date()
    .default(() => `${new Date().toLocaleString('en-US', { month: 'long' })} ${new Date().getFullYear()}`).nullable()
    .min( yup.ref('since'), "end date can't be before start date")
    ,
  positions: yup.array()
    .of(
      yup.object().shape(
        {
          name: yup.string().required(IS_REQUIRED('Position')),
          projects: yup.array()
            .of(
              yup.object().shape(
                {
                  name: yup.string().required(IS_REQUIRED('name')),
                  description: yup.string().required(IS_REQUIRED('description')),
                }),
            )
        }),
    )
    .required("Must have a position")
    .min(1, "Minimum of 1 position")
  
});
